import { render } from "./AppSettings.vue?vue&type=template&id=5c47375a&scoped=true"
const script = {}

import "./AppSettings.vue?vue&type=style&index=0&id=5c47375a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5c47375a"

export default script